/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RetrieveRecourseCriteriaRestResponse } from '../../models/retrieve-recourse-criteria-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface FindAllRecourseCriteria$Params {}

export function findAllRecourseCriteria(
  http: HttpClient,
  rootUrl: string,
  params?: FindAllRecourseCriteria$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<RetrieveRecourseCriteriaRestResponse>>> {
  const rb = new RequestBuilder(rootUrl, findAllRecourseCriteria.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RetrieveRecourseCriteriaRestResponse>>;
    }),
  );
}

findAllRecourseCriteria.PATH = '/recourse-criteria';
